import React, { Component } from 'react'
import { Button, DatePicker, Form, Modal } from 'antd'
import moment from 'moment'
import _ from 'lodash'

import './DueDateModal.scss'

const FormItem = Form.Item

export default class DueDateModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            modalVisible: false,
            projectDue: undefined,
            documentDue: undefined
        }

        this.handleClick = this.handleClick.bind(this)
        this.handleCancel = this.handleCancel.bind(this)
        this.handleConfirm = this.handleConfirm.bind(this)
        this.handleProjectDueChange = this.handleProjectDueChange.bind(this)
        this.handleDocumentDueChange = this.handleDocumentDueChange.bind(this)
    }

    handleClick() {
        this.setState({ modalVisible: true })
    }

    handleCancel() {
        this.setState({ modalVisible: false })
    }

    handleConfirm() {
        const { onConfirm } = this.props
        const { projectDue, documentDue } = this.state

        onConfirm(projectDue, documentDue)

        this.setState({ modalVisible: false })
    }

    handleProjectDueChange(date, dateString) {
        this.setState({ projectDue: moment(dateString).startOf('day') })
    }

    handleDocumentDueChange(date, dateString) {
        this.setState({ documentDue: moment(dateString).startOf('day') })
    }

    componentDidUpdate(prevProps, prevState) {
        const { projectDue, documentDue } = this.props
        const { modalVisible } = this.state
        if (!_.isEqual(prevProps.documentDue, documentDue))
            this.setState({ documentDue: documentDue ? moment(documentDue) : null })
        if (!_.isEqual(prevProps.projectDue, projectDue))
            this.setState({ projectDue: projectDue ? moment(projectDue) : null })

        if (prevState.modalVisible !== modalVisible && modalVisible) {
            this.setState({ documentDue: documentDue ? moment(documentDue) : null, projectDue: projectDue ? moment(projectDue) : null })
        }
    }

    render() {
        const { disabled } = this.props
        const { modalVisible, projectDue, documentDue } = this.state

        return (
            <div className="DueDateModal-wrapper cheer-btn">
                <Button type="primary" size="large" onClick={this.handleClick} disabled={disabled}>Due Date</Button>
                <Modal
                    width="60%"
                    wrapClassName="DueDateModal"
                    footer={null}
                    visible={modalVisible}
                    onCancel={this.handleCancel}
                >
                    <p className="info">Alert system will notify you 3 days before the due date.</p>
                    <div className="content">
                        <Form>
                            <FormItem
                                label="Project Due Date"
                                labelCol={{ span: 11 }}
                                wrapperCol={{ span: 13 }}
                            >
                                <DatePicker 
                                    placeholder="Select Date" 
                                    value={projectDue}
                                    onChange={this.handleProjectDueChange}
                                />
                            </FormItem>
                            <FormItem
                                label="Document Due Date"
                                labelCol={{ span: 11 }}
                                wrapperCol={{ span: 13 }}
                            >
                                <DatePicker 
                                    placeholder="Select Date" 
                                    value={documentDue}
                                    onChange={this.handleDocumentDueChange}
                                />
                            </FormItem>
                        </Form>
                    </div>
                    <div className="footer">
                        <Button type="primary" size="large" onClick={this.handleConfirm}>Save</Button>
                    </div>
                </Modal>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Commons/DueDateModal/DueDateModal.js